module.exports = "<div class=\"topbar__help topbar__help-close \">\n  <a  id=\"open-help\">\n    Ayuda\n    <img src=\"../assets/img/help-icon.svg\" alt=\"\">\n  </a>\n  <a  id=\"close-help\">\n    Cerrar ayuda\n    <img src=\"../assets/img/help-close-icon.svg\" alt=\"\">\n  </a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ayuda/ayuda.component.html
// module id = ./src/app/ayuda/ayuda.component.html
// module chunks = main